import { render } from "./OnboardGuestView.vue?vue&type=template&id=ab0cbcf0&scoped=true"
import script from "./OnboardGuestView.vue?vue&type=script&lang=js"
export * from "./OnboardGuestView.vue?vue&type=script&lang=js"

import "./OnboardGuestView.vue?vue&type=style&index=0&id=ab0cbcf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab0cbcf0"]])

export default __exports__